import { AxiosError, AxiosResponse } from 'axios'

import logger from '@/utils/_legacy/logger'

const getResponseErrorMessage = (res: unknown, includeStack = false): string | null => {
  if (!res) {
    return null
  }

  const response = res as AxiosError | AxiosResponse

  try {
    if ('data' in response && typeof response.data === 'object') {
      return getResponseErrorMessage(response.data, includeStack)
    }
    if ('data' in response && typeof response.data === 'string') {
      return response.data
    }
    if ('response' in response) {
      return getResponseErrorMessage(response.response, includeStack)
    }
    if ('message' in response) {
      if ('stack' in response && includeStack) {
        return `${response.message}: ${response.stack}`
      }
      return response.message
    }
    if ('error' in response && typeof response.error === 'string') {
      return response.error
    }
    if (typeof res === 'string') {
      return res
    }
    // return null in case we want to display a custom error message to the user,
    // rather than the whole error object
    return null
  } catch (error) {
    logger.error(error)
    return null
  }
}

export default getResponseErrorMessage
